function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "eq6ea",
  d: "M1017.896 3182c.61 0 1.104-.494 1.104-1.104v-17.792c0-.61-.494-1.104-1.104-1.104h-17.792c-.61 0-1.104.494-1.104 1.104v17.792c0 .61.494 1.104 1.104 1.104h17.792z"
}), React.createElement("path", {
  id: "eq6eb",
  d: "M1012.803 3182v-7.746h2.6l.39-3.018h-2.99v-1.927c0-.874.243-1.47 1.496-1.47h1.599v-2.7a21.39 21.39 0 0 0-2.33-.119c-2.304 0-3.882 1.407-3.882 3.99v2.226h-2.606v3.018h2.606V3182h3.117z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-999 -3162)"
}, React.createElement("use", {
  fill: "#485a96",
  xlinkHref: "#eq6ea"
})), React.createElement("g", {
  transform: "translate(-999 -3162)"
}, React.createElement("use", {
  fill: "#fff",
  xlinkHref: "#eq6eb"
})));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.5abf7e2c.svg";
export { ForwardRef as ReactComponent };